import * as places from './actions';
import { ActionType, getType } from 'typesafe-actions';
import { PlaceState, PlaceResponse } from './types';

const defaultState: PlaceState = {
  parkMap: {},
  searchTextInVisited: '',
  placesOnDisplayInHome: [],
  searchTextInHome: '',
  searchTextInBucketList: '',
  loading: false,
  tagFilters: [],
  stateFilters: [],
  places: [],
  favorites: {},
  visitedPlaces: {},
  bucketList: {},
  loadingMore: false,
  total: 496,
  getParkByCodeLoading: false,
  loadedParks: {},
  myList: {},
  parkStatsLoading: false,
  parkStats: {},
}

export default (state = defaultState, action: ActionType<typeof places>, page?: number): PlaceState => {
  switch (action.type) {
  case getType(places.updateParkMap):
    return {
      ...state,
      parkMap: JSON.parse(action.payload),
    };
  case getType(places.getParkStatByCodeAction.request):
    return {
      ...state,
      parkStatsLoading: true,
    };
  case getType(places.getParkStatByCodeAction.failure):
    return {
      ...state,
      parkStatsLoading: false,
    };
  case getType(places.getParkStatByCodeAction.success):
    return {
      ...state,
      parkStats: {
        ...state.parkStats,
        [action.payload.park.park_code]: {
          ...action.payload.park,
        },
      },
      parkStatsLoading: false,
    };
  case getType(places.updateTotal):
    return {
      ...state,
      total: action.payload,
    };
  case getType(places.showPlacesOnDisplay):
    return {
      ...state,
      placesOnDisplayInHome: action.payload,
      // placesOnDisplayInHome: action.payload,
    };
  case getType(places.setSearchTextInVisited):
    return {
      ...state,
      searchTextInVisited: action.payload
    };
  case getType(places.setSearchTextInHome):
    return {
      ...state,
      searchTextInHome: action.payload
    };
  case getType(places.setSearchTextInBucketList):
    return {
      ...state,
      searchTextInBucketList: action.payload,
    };
  // case getType(places.update):
  //   return {
  //     ...state,
  //   };
  /********************************************/
  case getType(places.updateNote.request):
  case getType(places.addDate.request):
  case getType(places.removeFavorite.request):
  case getType(places.addFavorite.request):
  case getType(places.addBucketList.request):
  case getType(places.removeBucketList.request):
  case getType(places.removeVisited.request):
  case getType(places.addVisited.request):
  case getType(places.getList.request):
    return {
      ...state,
    };
    case getType(places.updateNote.success):
  case getType(places.addDate.success):
  case getType(places.removeFavorite.success):
  case getType(places.addFavorite.success):
  case getType(places.removeVisited.success):
  case getType(places.addVisited.success):
  case getType(places.addBucketList.success):
  case getType(places.removeBucketList.success):
  case getType(places.getList.success):
    return {
      ...state,
      myList: {
        ...action.payload,
      },
    };
  /********************************************/
  case getType(places.fetchParkByCode.request):
    return {
      ...state,
      getParkByCodeLoading: true,
    }
  case getType(places.fetchParkByCode.success):
    if (action.payload.length === 0) {
      return {
        ...state,
        getParkByCodeLoading: false,
      };
    }
    return {
      ...state,
      getParkByCodeLoading: false,
      loadedParks: {
        // ...state.loadedParks,
        [action.payload[0].parkCode]: action.payload[0],
      },
    }
  /********************************************/
  case getType(places.fetchPlaces.request):
    return {
      ...state,
      loading: true,
    }
  case getType(places.fetchPlaces.success):
    const page = 1;
    const startIndex = (page - 1) * 20;
    const endIndex = startIndex + 20;
    return {
      ...state,
      places: action.payload,
      placesOnDisplayInHome: action.payload.slice(startIndex, endIndex),
      loading: false,
    }
  // case getType(places.getMorePages.request):
  //   return {
  //     ...state,
  //     loadingMore: true,
  //   }
  // case getType(places.searchPlaces.request):
  //   return {
  //     ...state,
  //     loading: true,
  //   }
  // case getType(places.getMorePages.success):
  //   return {
  //     ...state,
  //     places: state.places.concat(action.payload),
  //     loadingMore: false,
  //   };
  // case getType(places.searchPlaces.success):
  //   return {
  //     ...state,
  //     places: action.payload,
  //     loading: false,
  //   }
  case getType(places.addTagFilter):
    // const updatedTagFilters = state.tagFilters
    //   .concat(action.payload)
    //   .reduce((updatedList, item) => {
    //     if (!updatedList.indexOf(item)) {
    //       updatedList.push(item);
    //     }
    //     return updatedList;
    //   }, <string[]>[]);
    return {
      ...state,
    };
  case getType(places.removeTagFilter):
    return {
      ...state,
      tagFilters: state.tagFilters.filter(tn => tn !== action.payload)
    };
  case getType(places.updateTagFilters):
    return {
      ...state,
      tagFilters: action.payload
    };
  case getType(places.updateStateFilters):
      return {
        ...state,
        stateFilters: action.payload
      };
  case getType(places.updateFavoriteFilter):
    return {
      ...state,
      favorites: action.payload
    };
  
  default:
    return state;
  }
}
